import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { RemmiHistoryComponent } from './remmi-history.component';
import { FilterPipeModule } from '@pipes/filter-pipe/filter.module';

@NgModule({
  declarations: [RemmiHistoryComponent],
  imports: [CommonModule, FormsModule, TableModule, FilterPipeModule],
  exports: [RemmiHistoryComponent],
})
export class HistoryModule {}
